import React from 'react';

const SendBack = (extraStyles?: React.CSSProperties) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={extraStyles}>
            <path d="M11.6921 16L8 12L11.6921 8M8.51302 12H16" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 12C21 7.03125 16.9688 3 12 3C7.03125 3 3 7.03125 3 12C3 16.9688 7.03125 21 12 21C16.9688 21 21 16.9688 21 12Z" stroke="black" strokeMiterlimit="10"/>
        </svg>
    );
};

export default SendBack;

